// src/ui/AiCard.jsx — the strip above the composer that says Allo AI is armed,
// and the row that says it is thinking.
//
// 🟢 THE SAME TWO IDEAS AS THE PHONE, IN THIS CLIENT'S OWN LANGUAGE. The phone
//    reads its theme from a colours object; the browser reads it from custom
//    properties. Neither names a colour, which is the part that matters: the
//    card was a filled purple block on every theme, and a saturated slab of
//    somebody else's brand colour above the keyboard is the loudest thing on
//    the screen — about a state the person just chose on purpose.

import React from 'react';
import { Sparkles, X } from './icons';

/** Armed: the next message goes to Allo AI. */
export function AiComposerCard({ onClose }) {
  return (
    <div className="ai-card">
      <Sparkles width={16} height={16} />
      <div className="ai-card-t">
        <b>Allo AI</b>
        <span>Answers in this chat, from this chat</span>
      </div>
      <button className="ai-card-x" onClick={onClose} aria-label="Cancel Allo AI">
        <X width={15} height={15} />
      </button>
    </div>
  );
}

/**
 * Thinking.
 *
 * 🟥 IT SITS AFTER THE LIST, NOT IN IT, and that is the whole reason this
 *    client cannot have the bug the phone had. The phone concatenated its
 *    thinking row into the messages array, where two sort rules fought over
 *    whether it or the message you just sent was newer, and the two swapped in
 *    front of you the moment the send confirmed. A row that is not in the list
 *    cannot be sorted into the wrong place in it.
 */
export function AiThinking({ mine }) {
  return (
    <div className={`ai-think ${mine ? 'out' : 'in'}`}>
      <span className="ai-think-b">
        <Sparkles width={13} height={13} />
        <i /><i /><i />
      </span>
    </div>
  );
}

export default AiComposerCard;
